import { cartOfferLoader } from "../../loaders/cart/cartOfferLoader";

export const cartOfferCases = (builder: any) => {
    builder
    .addCase(cartOfferLoader.pending, (state: any, action: any) => {
        const {isMini, all} = action.meta.arg;

        if (all) {
            state.loading.cartOffer = true;
            state.loading.miniCart = true;
        } else if (isMini) {
            state.loading.miniCart = true;
        } else {
            state.loading.cartOffer = true;
        }
    })
    .addCase(cartOfferLoader.fulfilled, (state: any, action: any) => {
        const {data, isMini, all} = action.payload;

        if (all) {
            state.cartOffer = data;
            state.miniCart = data;
        } else if (isMini) {
            state.miniCart = data;
        } else {
            state.cartOffer = data;
        }

        state.loading.cartOffer = false;
        state.loading.miniCart = false;
    })
    .addCase(cartOfferLoader.rejected, (state: any, action: any) => {
        state.error.cartOffer = action.payload;
        state.loading.cartOffer = false;
        state.loading.miniCart = false;
    });

return builder;
}